import { DEFAULT_LANG } from "constants/common.constants";
import { UNIT_SYSTEM } from "constants/units.contants";
import { Unit } from "models/units";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AppState = {
  lang: string;
  unitSystem: Unit;
};

const initialAppState: AppState = {
  lang: DEFAULT_LANG,
  unitSystem: UNIT_SYSTEM.METRIC,
};

const app = createSlice({
  name: "app",
  initialState: initialAppState,
  reducers: {
    setLang: (state, action: PayloadAction<string>) => {
      state.lang = action.payload;
    },
    setUnitSystem: (state, action: PayloadAction<Unit>) => {
      state.unitSystem = action.payload;
    },
  },
});

export const { setLang, setUnitSystem } = app.actions;

export default app.reducer;
